import React from "react";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { IntercomConversationAuthorApi } from "../../../../../../../../services/Api/Admin/adminTypes";

interface Props {
	author: IntercomConversationAuthorApi;
	createdAt: string;
}

const ConversationAuthor = ({ author, createdAt }: Props) => {
	return (
		<div className="intercom-author">
			<div className="intercom-info">{author.name}</div>
			<div className="date">{FormatDate(createdAt)}</div>
		</div>
	);
};
export default ConversationAuthor;
